export default __webpack_public_path__ + "static/office-5280d4e65d2e237b552dc99ca2ead43e.jpg";